<template>
	<div class="row-item row-item_side left">
		<ul class="left-list">
			<li class="left-item" v-for="item in $store.state.categories.items" :key="item.id">
				<nuxt-link class="left-itemLink" :to="'/services/' + item.pseudoname">{{ item.name }}</nuxt-link>
			</li>
			<li class="left-item">
				<nuxt-link class="left-itemLink" href="/services" to="/services" exact>Мероприятия</nuxt-link>
			</li>
		</ul>
	</div>
</template>

<script>
export default {};
</script>
